


















import { Component, Vue } from "vue-property-decorator";
import { Checkbox, CheckboxGroup, Button } from "vant";
import { jumpLink,goBack } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

@Component({
  name: 'AccountResult',
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button
  }
})
export default class AccountResult extends Vue {
  showPage = false;
  result = {};
  created() {
    this.showPage = false;
    const { open_info_record_id, fromChangInfoPage } =  (this as any).$route.query;
    if( fromChangInfoPage == 1 && open_info_record_id != ''){
      (this as any).$apis
        .accountSupplementUpdate({
          open_info_record_id
        })
          .then(res => {
          this.showPage = true;
          this.result = res;
        })
          .catch(e => {
            
          });

    }else{
      (this as any).$apis
        .submitCreateAccountInfo()
        .then(res => {
          this.showPage = true;
          this.result = res;
        })
        .catch(e => {
          
        });
    }
  }

  handleCompleteCreateAccount() {
    if (browser.isApp) {
      if(browser.isIdcApp){
        let goUrl = browser.idcUrl || (window as any).$config.VUE_APP_IDC_ACTIVITY_URL
        window.location.href = goUrl + '#/?success=1';
        return
      }
	  if(browser.isGetProApp){
	  		goBack();
	  		// window.location.href = (window as any).$config.VUE_APP_GetPro_ACTIVITY_URL;
	  		return
	  }


      jumpLink("refresh_user");
    } else {
      this.$router.push("/");
    }
  }
}
